import * as effects from "redux-saga/effects";
const { call, put } = effects;
const takeEvery = (effects as any).takeEvery;

import { DISPATCH_TYPE } from "utils/enums.js";
import { getEnvironmentPaths, getPlatform } from "utils/utils.js";
import * as spAPI from "utils/sharepointAPI.js";
import { buildSelectQuery, buildListUrl } from "utils/SpUtility.js";
import {
  guestClientTypeProperties,
  guestCombinationProperties,
  guestFAQProperties,
  guestImportDateProperties,
  guestKeywordProperties,
  guestQuestionTypeProperties,
  guestSectionProperties,
  logpClientTypeProperties,
  logpCombinationProperties,
  logpFAQProperties,
  logpFAQFileProperties,
  logpKeywordProperties,
  logpQuestionTypeProperties,
  logpSectionProperties,
  guestFAQFileProperties
} from "utils/ListProperties.js";
import {
  IClientType,
  ICombinationAll,
  IFAQ,
  IFAQFile,
  IImportDate,
  IKeyword,
  IQuestionType,
  ISection,
  IUser
} from "@/types/SPTypes.tsx";

function* getInitialData() {
  try {
    yield put({ type: DISPATCH_TYPE.SET_IS_LOADING, payload: true });
    let env = getEnvironmentPaths();
    let url;

    yield call(getFAQsSaga);
    yield call(getFAQFilesSaga);
    yield call(getSectionsSaga);
    yield call(getQuestionTypesSaga);
    yield call(getClientTypesSaga);
    yield call(getKeywordsSaga);
    yield call(getCombinationsSaga);
    const isLoggedIn = getPlatform();

    if (!isLoggedIn) {
      yield call(getImportDateSaga);
    }

    //User
    url = `${env.webapi}/CurrentUser`;
    let user: IUser[] = yield call(() => spAPI.get(url));

    if (!user || user.length === 0) {
      // if user's not logged in
      yield put({ type: DISPATCH_TYPE.SET_CURRENTUSER, payload: null });
      yield put({ type: DISPATCH_TYPE.SET_CURRENTUSER_EMAIL, payload: null });
    } else {
      yield put({ type: DISPATCH_TYPE.SET_CURRENTUSER, payload: user[0] });
      yield put({
        type: DISPATCH_TYPE.SET_CURRENTUSER_EMAIL,
        payload: user[0].Email ?? null
      });
    }

    yield put({ type: DISPATCH_TYPE.SET_IS_LOADING, payload: false });
  } catch (error) {
    console.log(error);
  }
}

export function* getFAQsSaga() {
  const isLoggedIn = getPlatform();

  let queryString;
  if (isLoggedIn || window.location.href.includes("logp")) {
    // added window.location.href.includes("logp") becuase the FAQ call is made before isLoggedIn is set
    queryString =
      buildListUrl("FAQs") +
      buildSelectQuery(logpFAQProperties) +
      "&$filter=public eq 1";
  } else {
    queryString = buildListUrl("FAQs") + buildSelectQuery(guestFAQProperties);
  }
  try {
    const FAQs: IFAQ[] = yield call(() => spAPI.get(queryString));
    yield put({ type: DISPATCH_TYPE.SET_FAQ_DATA, payload: FAQs });
  } catch (error) {
    console.log(error);
  }
}

export function* getFAQFilesSaga() {
  const isLoggedIn = getPlatform();
  const queryString =
    buildListUrl("FAQFiles") +
    buildSelectQuery(
      isLoggedIn ? logpFAQFileProperties : guestFAQFileProperties
    );
  try {
    const FAQFiles: IFAQFile[] = yield call(() => spAPI.get(queryString));
    yield put({
      type: DISPATCH_TYPE.SET_FAQ_FILES,
      payload: FAQFiles
    });
  } catch (error) {
    console.log(error);
  }
}

export function* getSectionsSaga() {
  const isLoggedIn = getPlatform();
  const queryString =
    buildListUrl("Sections") +
    buildSelectQuery(
      isLoggedIn ? logpSectionProperties : guestSectionProperties
    );
  try {
    const sections: ISection[] = yield call(() => spAPI.get(queryString));
    yield put({
      type: DISPATCH_TYPE.SET_SECTIONS,
      payload: sections
    });
  } catch (error) {
    console.log(error);
  }
}

export function* getQuestionTypesSaga() {
  const isLoggedIn = getPlatform();
  const queryString =
    buildListUrl("QuestionTypes") +
    buildSelectQuery(
      isLoggedIn ? logpQuestionTypeProperties : guestQuestionTypeProperties
    );
  try {
    const questionTypes: IQuestionType[] = yield call(() =>
      spAPI.get(queryString)
    );
    yield put({
      type: DISPATCH_TYPE.SET_QUESTION_TYPES,
      payload: questionTypes
    });
  } catch (error) {
    console.log(error);
  }
}

export function* getClientTypesSaga() {
  const isLoggedIn = getPlatform();
  const queryString =
    buildListUrl("ClientTypes") +
    buildSelectQuery(
      isLoggedIn ? logpClientTypeProperties : guestClientTypeProperties
    );

  try {
    const clientTypes: IClientType[] = yield call(() => spAPI.get(queryString));
    yield put({
      type: DISPATCH_TYPE.SET_CLIENT_TYPES,
      payload: clientTypes
    });
  } catch (error) {
    console.log(error);
  }
}

export function* getKeywordsSaga() {
  const isLoggedIn = getPlatform();
  const queryString =
    buildListUrl("Keywords") +
    buildSelectQuery(
      isLoggedIn ? logpKeywordProperties : guestKeywordProperties
    );

  try {
    const keywords: IKeyword[] = yield call(() => spAPI.get(queryString));
    yield put({
      type: DISPATCH_TYPE.SET_KEYWORDS,
      payload: keywords
    });
  } catch (error) {
    console.log(error);
  }
}

export function* getCombinationsSaga() {
  const isLoggedIn = getPlatform();
  const queryString =
    buildListUrl("Combinations") +
    buildSelectQuery(
      isLoggedIn ? logpCombinationProperties : guestCombinationProperties
    );

  try {
    const allCombinations: ICombinationAll[] = yield call(() =>
      spAPI.get(queryString)
    );
    yield put({
      type: DISPATCH_TYPE.SET_COMBINATIONS,
      payload: allCombinations
    });
  } catch (error) {
    console.log(error);
  }
}

export function* getImportDateSaga() {
  const queryString =
    buildListUrl("ImportDate") + buildSelectQuery(guestImportDateProperties);
  try {
    const importDate: IImportDate = yield call(() => spAPI.get(queryString));
    yield put({ type: DISPATCH_TYPE.SET_IMPORT_DATE, payload: importDate });
  } catch (error) {
    console.log(error);
  }
}

function* generalSaga() {
  yield takeEvery(DISPATCH_TYPE.GET_INITIAL_DATA, getInitialData);
}

export default generalSaga;
